import {LOCALE_ID, NgModule} from '@angular/core';
import {APP_BASE_HREF, registerLocaleData} from '@angular/common';
import localeit from '@angular/common/locales/it';
import {BrowserModule, HammerModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {AemModule, isInEditor} from '@myvf/aem';
import {CORE_CONFIGURATION, CoreModule} from '@myvf/core';
import {AppUiModule} from './app-ui.module';
import {MyvfSharedModule} from '@myvf/shared';

import {NgxsModule} from '@ngxs/store';
import {NgxsRouterPluginModule} from '@ngxs/router-plugin';
import {NgxsLoggerPluginModule} from '@ngxs/logger-plugin';
import {NgxsReduxDevtoolsPluginModule} from '@ngxs/devtools-plugin';

import {AppRoutingModule} from './app-routing.module';
import {ContainerComponent} from './container/container.component';

import {environment} from '../environments/environment';
import {CustomErrorService} from './core/api/custom-error.service';
import {CustomErrorSharedService} from './shared/errors/custom-error-shared.service';
import { LandlineCardComponent } from './change/component/landline-card/landline-card.component';

registerLocaleData(localeit);

export function CoreConfigurationFactory() {
  return {
    production: environment.production,
    environment: environment.name,
    apiHost: environment.api,
    apiHostAWS: environment.apiAWS,
    apiKeycloakHost: environment.apiKeycloak,
    apiBasePath: environment.apiBasePath,
    enableTracing: !environment.production,
    isInEditor: !!isInEditor(),
    aemBasePath:environment.aemBasePath,
    errorPageNotFound: '/content/myvf-business/webviews/error/page-not-found.html',
    errorPageAccessDenied: '/content/myvf-business/webviews/error/access-denied.html'
  };
}

@NgModule({
  declarations: [ContainerComponent],
  imports: [
    BrowserModule.withServerTransition({appId: 'myvf-business'}),
    BrowserAnimationsModule,
    NgxsModule.forRoot([], {developmentMode: !environment.production}),
    NgxsRouterPluginModule.forRoot(),
    NgxsLoggerPluginModule.forRoot({
      disabled: environment.production
    }),
    NgxsReduxDevtoolsPluginModule.forRoot({
      disabled: environment.production
    }),
    AppRoutingModule,
    AppUiModule,
    MyvfSharedModule,
    CoreModule.forRoot(),
    AemModule.forRoot({
      host: environment.aem
    }),
    HammerModule
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'it'
    },
    {
      provide: APP_BASE_HREF,
      useValue: '/'
    },
    {
      provide: CORE_CONFIGURATION,
      useFactory: CoreConfigurationFactory
    },
    {
      provide: CustomErrorService,
      useClass: CustomErrorSharedService
    }
  ],
  bootstrap: [ContainerComponent]
})
export class AppModule {
}
